export default __webpack_public_path__ + "static/media/regulatory--end-of-no-overtaking-by-heavy-goods-vehicles--g2.16e2a814.png";